import AbstractTool from "./AbstractTool";
import Modal from "../gui/Modal";
import { updateUnitSystem } from "../shared/utils";

export default class AbstractSettingsTool extends AbstractTool {
    constructor(provider) {
        super(provider);

        this.settingsMenu = new Modal(provider);
        this.settingsMenu
            .onClickOutside(() => {
                this.settings.store();
                this.tools.setPreviousTool();
            })
            .setTitle('Settings')
            .setButtonText('Done')
            .onClickButton(() => {
                this.settings.store();
                this.tools.setPreviousTool();
            })
            .hide();

        this.addOptions();
    }

    addOptions() {
        this.settingsMenu.addContent(this.createCheckboxes());
        this.settingsMenu.addContent(this.createUnitOption());
    }

    createCheckboxes() {
        let container = this.p.createDiv().class('input-group -has-checkbox');
        this.createGridOption(container);
        this.createLabelOption(container);
        this.createShowImageOption(container);
        return container;
    }

    createGridOption(container) {
        this.settings.showGridCheckbox = this.p.createCheckbox('Show grid', true)
            .parent(container);
        this.settings.showGridCheckbox.elt.firstChild.firstChild.id = 'show-grid';
    }

    createLabelOption(container) {
        this.settings.showLabelCheckbox = this.p.createCheckbox('Show labels', true)
            .parent(container);
        this.settings.showLabelCheckbox.elt.firstChild.firstChild.id = 'show-labels';
    }

    createShowImageOption(container) {
        this.settings.showImageCheckbox = this.p.createCheckbox('Show image', true)
            .parent(container);
        this.settings.showImageCheckbox.changed(() => {
            this.imageMenu?.showImageCheckbox.checked(this.settings.showImageCheckbox.checked());
        });
        this.settings.showImageCheckbox.elt.firstChild.firstChild.id = 'show-image';
    }

    createUnitOption() {
        let unitWrapper = this.p.createDiv().class('input-group input-select-wrapper');
        this.settings.unitSelector = this.p.createSelect()
            .parent(unitWrapper)
            .class('input-select')
            .id('unit-system');
        this.settings.unitSelector.option('Metric system (m/cm)', 'metric');
        this.settings.unitSelector.option('Imperial system (ft/in)', 'imperial');
        this.settings.unitSelector.changed(() => updateUnitSystem(this.provider));
        return unitWrapper;
    }

    activate() {
        this.settingsMenu.show();
        this.settingsMenu.addClass('-is-active');
        this.enableHotKeys = false;
    }

    deactivate() {
        this.settingsMenu.hide();
        this.settingsMenu.removeClass('-is-active');
        this.enableHotKeys = true;
    }

    pressKeyHotKeysDisabled(code) {
        switch (code) {
            case 27: // Escape
                this.settings.store();
                this.tools.setPreviousTool();
                break;
        }
    }
}
